import { useEffect, useState } from "react";
import { Box, Grid, TextField } from "@mui/material";

import {
  Content,
  Title,
  Wrapper,
  Center,
  ImgWrp,
  BtnDownload,
  ButtomLabel,
  ImgContent,
  ExitBtn,
} from "./PersonalData.styles";
import FastBottom from "../../../../shared/FastButton";
import FastIcon from "../../../../shared/FastIcon";
import { profileService } from "../../../../services/profile.service";
import useSnackBar from "../../../../hooks/useSnackBar";

const PersonalData = ({ info, setInfo }: any) => {
  const [requiredFirstName, setRequiredFirstName] = useState(false);
  const [requiredLastName, setRequiredLastName] = useState(false);
  const { setSnackBar } = useSnackBar();
  const [file, setFile] = useState("");
  useEffect(() => {
    setFile(info.avatar ?? "");
  }, [info]);

  function toDataURL(url: any, callback: any) {
    let xhr = new XMLHttpRequest();
    xhr.onload = function () {
      let reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  }

  const uploadImg = (e: any) => {
    setFile(URL.createObjectURL(e.target.files[0]));
    toDataURL(
      URL.createObjectURL(e.target.files[0]),
      function (dataUrl: string) {
        profileService
          .uploadAvatar({ file: dataUrl })
          .then((data: any) => console.log(data));
      }
    );
  };

  const deleteImg = () => {
    profileService.deleteAvatar().then(() => {
      setFile("");
    });
  };

  const submit = () => {
    if (!info.first_name || !info.last_name) {
      setRequiredFirstName(!info.first_name);
      setRequiredLastName(!info.last_name);
      return;
    }

    profileService
      .postProfile(info)
      .then(() => {
        setSnackBar({
          title: "Данные успешно обновлены",
          isActive: true,
          status: "success",
        });
      })
      .catch((e) => {
        setSnackBar({
          title: e.response.data.detail,
          isActive: true,
          status: "error",
        });
      });
  };

  return (
    <Box component="form">
      <Wrapper>
        <Title>Основные данные</Title>
        <Content>
          <Box>
            <ImgWrp>
              {file ? (
                <ExitBtn onClick={() => deleteImg()}>
                  <FastIcon name={"trash"} width={20} height={20} />
                </ExitBtn>
              ) : null}
              {file ? <ImgContent src={file} /> : <FastIcon name={"avatar"} />}

              {file ? null : (
                <ButtomLabel>
                  <BtnDownload
                    type="file"
                    name="file"
                    accept={"image/*"}
                    onChange={(e: any) => uploadImg(e)}
                  />
                  Загрузить
                </ButtomLabel>
              )}
            </ImgWrp>
          </Box>

          <Box>
            <Grid
              container
              spacing={{ xs: 0, md: 3 }}
              sx={{
                "@media (max-width: 1000px)": {
                  flexDirection: "column",
                  paddingLeft: "0",
                  paddingTop: "0",
                },
              }}>
              <Grid
                item
                xs={6}
                md={4}
                sx={{
                  "@media (max-width: 1000px)": {
                    flexBasis: "100%",
                    maxWidth: "100%",
                  },
                }}>
                <TextField
                  label={"Имя"}
                  name="name"
                  className="labelBackground"
                  error={requiredFirstName}
                  helperText={requiredFirstName ? "Это обязательное поле" : ""}
                  value={info?.first_name || ""}
                  onChange={(e: any) => {
                    setRequiredFirstName(false);
                    setInfo({ ...info, first_name: e.target.value });
                  }}
                />
              </Grid>

              <Grid
                item
                xs={6}
                md={4}
                sx={{
                  "@media (max-width: 1000px)": {
                    flexBasis: "100%",
                    maxWidth: "100%",
                    mt: "16px",
                  },
                }}>
                <TextField
                  label={"Фамилия"}
                  value={info?.last_name || ""}
                  name="surname"
                  error={requiredLastName}
                  className="labelBackground"
                  helperText={requiredLastName ? "Это обязательное поле" : ""}
                  onChange={(e) => {
                    setRequiredLastName(false);
                    setInfo({ ...info, last_name: e.target.value });
                  }}
                />
              </Grid>

              <Grid
                item
                xs={6}
                md={4}
                sx={{
                  "@media (max-width: 1000px)": {
                    flexBasis: "100%",
                    maxWidth: "100%",
                    mt: "16px",
                  },
                }}>
                <TextField
                  label={"Отчество"}
                  value={info?.patronymic || ""}
                  name="secondname"
                  onChange={(e) =>
                    setInfo({ ...info, patronymic: e.target.value })
                  }
                />
              </Grid>

              <Grid
                item
                xs={6}
                md={12}
                sx={{
                  "@media (max-width: 1000px)": {
                    flexBasis: "100%",
                    maxWidth: "100%",
                    mt: "16px",
                  },
                }}>
                <TextField
                  label={"Биография"}
                  name="biography"
                  multiline
                  rows={4}
                  value={info?.biography || ""}
                  onChange={(e: any) =>
                    setInfo({ ...info, biography: e.target.value })
                  }
                />
              </Grid>
            </Grid>
          </Box>
        </Content>
      </Wrapper>

      <Wrapper style={{ marginBottom: "32px" }}>
        <Title>Ссылки</Title>

        <Box>
          <Grid
            container
            rowSpacing={{ xs: "24px" }}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            sx={{
              "@media (max-width: 1000px)": {
                m: 0,
                flexDirection: "column",
              },
            }}>
            <Grid
              item
              xs={6}
              sx={{
                "@media (max-width: 1000px)": {
                  flexBasis: "100%",
                  maxWidth: "100%",
                  p: "0 !important",
                },
              }}>
              <TextField
                label={"Сайт"}
                value={info?.link_site || ""}
                name="link_site"
                onChange={(e: any) =>
                  setInfo({ ...info, link_site: e.target.value })
                }
              />
            </Grid>
            <Grid
              item
              xs={6}
              sx={{
                "@media (max-width: 1000px)": {
                  flexBasis: "100%",
                  maxWidth: "100%",
                  mt: "16px",
                  p: "0 !important",
                },
              }}>
              <TextField
                label={"Instagram"}
                value={info?.link_instagram || ""}
                name="link_instagram"
                onChange={(e: any) =>
                  setInfo({ ...info, link_instagram: e.target.value })
                }
              />
            </Grid>
            <Grid
              item
              xs={6}
              sx={{
                "@media (max-width: 1000px)": {
                  flexBasis: "100%",
                  maxWidth: "100%",
                  mt: "16px",
                  p: "0 !important",
                },
              }}>
              <TextField
                label={"YouTube"}
                value={info?.link_youtube || ""}
                name="link_youtube"
                onChange={(e: any) =>
                  setInfo({ ...info, link_youtube: e.target.value })
                }
              />
            </Grid>
            <Grid
              item
              xs={6}
              sx={{
                "@media (max-width: 1000px)": {
                  flexBasis: "100%",
                  maxWidth: "100%",
                  mt: "16px",
                  p: "0 !important",
                },
              }}>
              <TextField
                label={"LinkedIn"}
                value={info?.link_linkedin || ""}
                name="link_linkedin"
                onChange={(e: any) =>
                  setInfo({ ...info, link_linkedin: e.target.value })
                }
              />
            </Grid>
            <Grid
              item
              xs={6}
              sx={{
                "@media (max-width: 1000px)": {
                  flexBasis: "100%",
                  maxWidth: "100%",
                  mt: "16px",
                  p: "0 !important",
                },
              }}>
              <TextField
                label={"Twitter"}
                value={info?.link_twitter || ""}
                name="link_twitter"
                onChange={(e: any) =>
                  setInfo({ ...info, link_twitter: e.target.value })
                }
              />
            </Grid>
            <Grid
              item
              xs={6}
              sx={{
                "@media (max-width: 1000px)": {
                  flexBasis: "100%",
                  maxWidth: "100%",
                  mt: "16px",
                  p: "0 !important",
                },
              }}>
              <TextField
                label={"Facebook"}
                value={info?.link_facebook || ""}
                name="link_facebook"
                onChange={(e: any) =>
                  setInfo({ ...info, link_facebook: e.target.value })
                }
              />
            </Grid>
          </Grid>
        </Box>
      </Wrapper>
      <Center>
        <FastBottom
          variant="contained"
          title={"Сохранить"}
          onClick={() => submit()}
        />
      </Center>
    </Box>
  );
};

export default PersonalData;
